var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('core-filter'),_c('core-toolbar',{staticStyle:{"width":"fixed"}}),_c('core-drawer'),_c('v-main',{staticStyle:{"background":"#eee","padding-top":"64px","width":"fixed"}},[_c('div',{attrs:{"id":"core-view"}},[_c('v-fade-transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1)],1),_c('core-footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }